import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import {
  getSelectedMeal,
  getSelectedMealModalStatus,
} from '../../../../redux/selectors/orderFormSelector';
import { mealExchangeChangeSelectedMealModalStatus } from '../../../../redux/actions/orderFormActions';
import Modal from 'react-modal';
import { getVisibleIngredients } from '../../../../redux/selectors/formSettingsSelector';
import MenuIcon from '../../../../assets/icons/menuIcon';
import { useAppDispatch, useAppSelector } from '../../../../config/hooks';
import { IngredientT } from '../types/ingredient.type';
import ThermoBadge from "../../../../features/badge/views/thermo/ThermoBadge";

const MealDetailsModal = () => {
  const dispatch = useAppDispatch();
  const selectedMeal = useAppSelector(getSelectedMeal);
  const showIngredients = useAppSelector(getVisibleIngredients);
  const modalStatus = useAppSelector(getSelectedMealModalStatus);

  const closeModal = () => {
    dispatch(dispatch(mealExchangeChangeSelectedMealModalStatus(false)));
  };

  const {
    allergens,
    ingredientCaloriesText,
    ingredientCarbohydrate,
    ingredientDietaryFiber,
    ingredientFat,
    ingredientProtein,
    ingredients,
    ingredientSalt,
    ingredientSaturatedFattyAcids,
    ingredientSugar,
    mealName,
    menuMealName,
    menuMealThermo,
  } = selectedMeal || {};

  const nutritional = [
    { title: 'Białko', value: ingredientProtein },
    { title: 'Tłuszcz', value: ingredientFat },
    { title: 'Węglowodany', value: ingredientCarbohydrate },
    { title: 'Błonnik', value: ingredientDietaryFiber },
    { title: 'Cukry', value: ingredientSugar },
    { title: 'Sól', value: ingredientSalt },
    { title: 'NKT', value: ingredientSaturatedFattyAcids },
  ];

  return (
    <Modal
      className="meal-modal"
      isOpen={modalStatus}
      onRequestClose={closeModal}
      overlayClassName="overlay-form-fixed"
    >
      <FontAwesomeIcon
        className="meal-modal__close font-size-18"
        icon={faTimes}
        onClick={closeModal}
      />
      <div className="meal-info">
        {menuMealThermo && <ThermoBadge thermo={menuMealThermo} />}
        <span>{mealName}</span>
        <h4 className="h400 spacer-bottom-24">{menuMealName}</h4>
        {!!ingredientCaloriesText && (
          <>
            <span>Wartości odżywcze</span>
            <h3 className="h300 spacer-bottom-16">{ingredientCaloriesText}</h3>
          </>
        )}

        <div className="meal-info__nutritional-values">
          {nutritional.map(
            ({ title, value }) =>
              !!value && (
                <div className="meal-info__item" key={title}>
                  <span>{title}</span> <span>{value}g</span>
                </div>
              )
          )}
        </div>

        {!!allergens && (
          <div className="spacer-top-24">
            <p className="body-m spacer-bottom-4">Alergeny</p>
            <p className="body-s">{allergens}</p>
          </div>
        )}

        {showIngredients ? (
          !!ingredients && (
            <>
              <p className="spacer-top-12">Składniki</p>
              <p className="body-s color-gray-800">
                {ingredients.map(({ major, name }: IngredientT) => (
                  <span
                    className={`spacer-right-4 ${
                      major ? 'font-weight-500' : ''
                    }`}
                    key={name}
                  >
                    {name}
                    {', '}
                  </span>
                ))}
              </p>
            </>
          )
        ) : (
          <>
            <div className="display-flex justify-content-center">
              <div className="user-icon-color">
                <MenuIcon height="120" width="120" />
              </div>
            </div>
            <p className="label-l text-align-center spacer-bottom-16">
              Brak podanych składników
            </p>
            <p className="text-m text-align-center">
              Jeśli potrzebujesz dokładnej rozpiski składników dnia, skontaktuj
              się z cateringiem.
            </p>
          </>
        )}
      </div>
    </Modal>
  );
};

export default MealDetailsModal;
